import React, { useState } from 'react'
import DonationCTA from '../components/DonationCTA'
import Hero from '../components/Hero'

export default function Ayuda() {
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = e.currentTarget
    const formData = new FormData(form)
    
    // Convert FormData to a regular object
    const data = {
      nombre: formData.get('nombre') as string,
      apellido: formData.get('apellido') as string,
      nombre_pequeno: formData.get('nombre_pequeno') as string,
      correo: formData.get('correo') as string,
      celular: formData.get('celular') as string,
      mensaje: formData.get('mensaje') as string,
    }
    
    try {
      const response = await fetch('/api/send-inscription-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      
      if (response.ok) {
        setSubmitted(true)
      } else {
        const errorData = await response.json()
        console.error('Error:', errorData)
        alert('Hubo un error al enviar el formulario. Por favor, intenta de nuevo.')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('Hubo un error al enviar el formulario. Por favor, intenta de nuevo.')
    }
  }

  return (
    <article className="min-h-screen">
      {/* Hero Section */}
      <Hero 
        title="Inscripciones"
        subtitle="Inscribe a tu pequeñx en nuestros programas educativos"
        backgroundImage="/images/banners/halloween_gaviota.jpg"
      />

      <div className="w-screen flex justify-center mb-32">
        <div className="w-full max-w-[1280px] px-8">
          {/* Valoración Section */}
          <section className="mt-32 mb-8">
            <h2 className="headline-medium mb-6">Valoración</h2>
            <div>
              <p className="body mb-6">
                Trabajamos con niños/as con y sin discapacidad de 1 a 10 años de edad, que cursan nivel inicial y preescolar. O bien, necesitan terapias del lenguaje o/y física, pueden llamar para hacer una cita para valoración con la trabajadora social.
              </p>
              <p className="body">
                Posterior a la valoración, el equipo de trabajo le explicará los servicios que se brindan los cuales pueden ser:
              </p>
            </div>
          </section>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {/* Presencial Section */}
            <div className="bg-white rounded-lg p-8">
              <h3 className="headline-small mb-4">Presencial y Estimulación Temprana</h3>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <svg className="w-5 h-5 mr-2 text-[#4285F4]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"/>
                  </svg>
                  <span className="body">Horario de 7:45am a 2:30pm</span>
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 mr-2 text-[#4285F4]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"/>
                  </svg>
                  <span className="body">Ofrecemos Estancia Infantil (8:00 a 2:45pm)</span>
                </li>
              </ul>
            </div>

            {/* Terapias Section */}
            <div className="bg-white rounded-lg p-8">
              <h3 className="headline-small mb-4">Terapias Individuales por Horario</h3>
              <p className="body mb-4">Desarrollo por atención específica como Ecología que recibirán tanto terapias físicas como del lenguaje</p>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <svg className="w-5 h-5 mr-2 text-[#4285F4]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"/>
                  </svg>
                  <span className="body">Horario de 8:00am a 3:00pm</span>
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 mr-2 text-[#4285F4]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"/>
                  </svg>
                  <span className="body">Ofrecemos Estancia Infantil (8:00 a 3:00pm)</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form Section */}
          <section className="mb-24 flex flex-col items-center">
            <h2 className="headline-medium mb-16">Realiza la inscripción de tu pequeñito o pequeñita</h2>
            <div className="rounded-lg w-full max-w-xl mx-auto flex flex-col">
              {submitted ? (
                <div className="text-center py-8">
                  <h3 className="headline-small mb-4">¡Gracias por tu mensaje!</h3>
                  <p className="body text-gray-600">Nos pondremos en contacto contigo pronto.</p>
                </div>
              ) : (
                <form
                  onSubmit={handleSubmit}
                  className="space-y-6"
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-1">
                        Nombre *
                      </label>
                      <input
                        type="text"
                        name="nombre"
                        id="nombre"
                        required
                        placeholder="Nombre"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent placeholder-gray-400"
                      />
                    </div>
                    <div>
                      <label htmlFor="apellido" className="block text-sm font-medium text-gray-700 mb-1">
                        Apellido *
                      </label>
                      <input
                        type="text"
                        name="apellido"
                        id="apellido"
                        required
                        placeholder="Apellido"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent placeholder-gray-400"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="nombre_pequeno" className="block text-sm font-medium text-gray-700 mb-1">
                      Nombre del pequeñx a inscribir *
                    </label>
                    <input
                      type="text"
                      name="nombre_pequeno"
                      id="nombre_pequeno"
                      required
                      placeholder="Nombre del pequeñx a inscribir"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent placeholder-gray-400"
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="correo" className="block text-sm font-medium text-gray-700 mb-1">
                        Correo *
                      </label>
                      <input
                        type="email"
                        name="correo"
                        id="correo"
                        required
                        placeholder="Correo electrónico"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent placeholder-gray-400"
                      />
                    </div>
                    <div>
                      <label htmlFor="celular" className="block text-sm font-medium text-gray-700 mb-1">
                        Celular *
                      </label>
                      <input
                        type="tel"
                        name="celular"
                        id="celular"
                        required
                        placeholder="Celular"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent placeholder-gray-400"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="mensaje" className="block text-sm font-medium text-gray-700 mb-1">
                      Mensaje adicional
                    </label>
                    <textarea
                      name="mensaje"
                      id="mensaje"
                      rows={4}
                      placeholder="Mensaje adicional"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent placeholder-gray-400"
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-[#FF5900] text-white py-3 px-6 rounded-full hover:bg-black transition-colors duration-300"
                  >
                    Enviar
                  </button>
                </form>
              )}
            </div>
          </section>

          {/* Banner */}
          <div
            className="w-screen h-[75vh] mb-16"
            style={{
              width: '100vw',
              marginLeft: 'calc(-50vw + 50%)',
              backgroundImage: 'url("/images/banners/class_gaviota.jpg")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
            role="img"
            aria-label="Decorative Banner"
          />

          {/* Inscripciones Section */}
          <div className="mb-0">
            <h2 className="headline-medium text-primary mb-4">Las inscripciones están abiertas todo el año</h2>
            <p className="body mb-12">Contamos con dos periodos de inscripciones independientes:</p>
            <div className="space-y-8 ">
              {/* Maternal */}
              <div className="bg-white rounded-lg p-8 flex items-start gap-4">
                <div className="text-[#4285F4] mt-1">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
                    <path d="M7 12H17V14H7V12ZM7 7H17V9H7V7ZM7 17H14V15H7V17Z" fill="currentColor"/>
                  </svg>
                </div>
                <div>
                  <h3 className="headline-small mb-2">Inscripciones para Maternal</h3>
                  <ul className="space-y-1 body">
                    <li>Inscripciones abiertas durante todo el ciclo escolar</li>
                    <li>A partir de un año de edad</li>
                    <li>Cita para una valoración</li>
                  </ul>
                </div>
              </div>
              {/* Kinder */}
              <div className="bg-white rounded-lg p-8 flex items-start gap-4">
                <div className="text-[#4285F4] mt-1">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" fill="currentColor"/>
                  </svg>
                </div>
                <div>
                  <h3 className="headline-small mb-2">Inscripciones para Kínder 1, 2 y 3</h3>
                  <ul className="space-y-1 body">
                    <li>Inscripciones abiertas durante todo el ciclo escolar</li>
                    <li>A partir de tres años hasta los 6 años de edad</li>
                    <li>Cita para una valoración</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Donation CTA */}
      <div className="-mt-16 mb-40">
        <DonationCTA />
      </div>
    </article>
  )
} 